module.exports = __webpack_public_path__ + "assets/img/title-afe8b9dc.png";